import {
  pgTable,
  uuid,
  text,
  timestamp,
  index,
} from "drizzle-orm/pg-core";
import { customers } from "./customers.js";
import { customerGroups } from "./customer-groups.js";
import { priceLists } from "./price-lists.js";
import { orders } from "./orders.js";

export const carts = pgTable(
  "carts",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    customerId: uuid("customer_id").references(() => customers.id, {
      onDelete: "cascade",
    }),
    sessionId: text("session_id"),
    convertedOrderId: uuid("converted_order_id").references(() => orders.id, {
      onDelete: "set null",
    }),
    lastActivityAt: timestamp("last_activity_at", { withTimezone: true })
      .notNull()
      .defaultNow(),
    customerEmail: text("customer_email"),
    customerFirstName: text("customer_first_name"),
    customerLastName: text("customer_last_name"),
    customerGroupId: uuid("customer_group_id").references(() => customerGroups.id),
    priceListId: uuid("price_list_id").references(() => priceLists.id),
    vatDisplay: text("vat_display").default("inc").$type<"inc" | "exc">(),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
  },
  (t) => ({
    customerIdx: index("carts_customer_id_idx").on(t.customerId),
    sessionIdx: index("carts_session_id_idx").on(t.sessionId),
    lastActivityIdx: index("carts_last_activity_at_idx").on(t.lastActivityAt),
  })
);

export type Cart = typeof carts.$inferSelect;
export type NewCart = typeof carts.$inferInsert;
